// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f10dff52","453":"cd474f6b","455":"4b7894e4"}[chunkId] + ".chunk.js";
};